import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { Applogo } from "../../../Routes/ImagePath";
import api from "../../../api";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [showResend, setShowResend] = useState(false);
  const navigate = useNavigate();
  const Applogo = process.env.REACT_APP_HEADER_LOGO_URL;
  // Timer Logic
  useEffect(() => {
    if (step === 2 && timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setStep(1); // Move to "Enter Number" screen when timer expires
    }
  }, [step, timer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };

  // Handle Send OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/send-otp", { phone });
      if (response.status === 200) {
        setStep(2);
        setTimer(30);
        setShowResend(false);
        setError("");
      } else {
        setError(response.data.message || "Failed to send OTP.");
      }
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred while sending OTP.");
    } finally {
      setLoading(false);
    }
  };

  // Handle Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/verify-otp", { otp, phone_number: phone });
      if (response.status === 200 && response.data.data === "true") {
        setStep(3);
        setError("");
      } else {
        setError(response.data.message || "Invalid OTP.");
      }
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred while verifying OTP.");
    } finally {
      setLoading(false);
    }
  };

  // Handle Set New Password
  const handleSetNewPassword = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      const response = await api.post("/set-new-password", {
        phone_number: phone,
        password,
        confirm_password: confirmPassword,
      });
      if (response.status === 200) {
        toast.success("Password Updated Successfully");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setError(response.data.message || "Failed to set new password.");
      }
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred while setting the new password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <Link to="/app/main/dashboard">
                <img src={Applogo} alt="Dreamguy's Technologies" />
              </Link>
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">Forgot Password?</h3>
                <p className="account-subtitle">
                  {step === 1 && "Enter your phone number to receive an OTP"}
                  {step === 2 && "Enter the OTP sent to your phone"}
                  {step === 3 && "Enter your new password"}
                </p>

                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={step === 1 ? handleSendOtp : step === 2 ? handleVerifyOtp : handleSetNewPassword}>
                  {step === 1 && (
                    <div className="input-block">
                      <label>Phone Number</label>
                      <input
                        className="form-control"
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                    </div>
                  )}

{step === 2 && (
  <>
    <div className="text-center my-3">
      <p>
        An OTP has been sent to <b>+91{phone}</b> &nbsp;
        <button
          className="btn btn-link d-inline-flex align-items-center"
          type="button"
          onClick={() => setStep(1)}
          style={{ padding: 0, margin: 0, textDecoration: "none" }}
        >
          {/* <span>Edit number</span>&nbsp; */}
          <i className="fas fa-edit"></i> {/* FontAwesome Icon */}
          
        </button>
      </p>
    </div>
    <div className="input-block">
      <label>OTP</label>
      <input
        className="form-control"
        type="text"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        required
      />
    </div>
    <div className="text-center my-3">
      {showResend ? (
        <button className="btn btn-link" type="button" onClick={handleSendOtp}>
          Resend OTP
        </button>
      ) : (
        <p>Time Remaining: {formatTime(timer)}</p>
      )}
    </div>
  </>
)}


                  {step === 3 && (
                    <>
                      <div className="input-block">
                        <label>New Password</label>
                        <input
                          className="form-control"
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>
                      <div className="input-block">
                        <label>Confirm New Password</label>
                        <input
                          className="form-control"
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </div>
                    </>
                  )}

                  <div className="input-block text-center">
                    <button className="btn btn-primary account-btn" type="submit" disabled={loading}>
                      {loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : step === 1 ? (
                        "Send OTP"
                      ) : step === 2 ? (
                        "Verify OTP"
                      ) : (
                        "Set New Password"
                      )}
                    </button>
                  </div>
                </form>

                {/* Always show "Remember your password?" */}
                <div className="account-footer text-center mt-3">
                  <p>
                    Remember your password? <Link to="/login">Login</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;
